import Analytics from 'config/Analytics';
import { getPaymentOptionKey } from 'payments/utils/FinalizePurchaseUtils';

import {
  handleAwaitingPaymentCompletion,
} from './SettingsActions';

const getStore = state => state.cart ? state.cart : state;

export const HANDLE_SELECT_PAYMENT_OPTION = 'HANDLE_SELECT_PAYMENT_OPTION';
export const handleSelectPaymentOption = ({ type, name, selectedSavedCard }) => (dispatch, getState) => {
  dispatch({
    type: HANDLE_SELECT_PAYMENT_OPTION,
    payload: {
      selectedOption: {
        type,
        name,
        selectedSavedCard,
      },
    },
  });

  const simulateLoadingWithWait = ['nb', 'wallet'];
  if (simulateLoadingWithWait.indexOf(type) !== -1) {
    setTimeout(() => {
      dispatch(handleHideLoader());
    }, 600);
  }

  const store = getStore(getState());
  try {
    /* globals MojoUser */
    Analytics.sendEvent('Selected Payment Mode', {
      'payment_mode': name,
      'buyer_id': MojoUser ? MojoUser.id : null,
      'order_id': store.settings.isRetrying ? store.retry.finalizePurchase.order :  store.finalizePurchase.order,
      'seller_username': store.settings.seller.username,
    });
  } catch (e) {}
};

export const HANDLE_SELECT_WALLET = 'HANDLE_SELECT_WALLET';
export const handleSelectWallet = ({
  walletId, paymentOption,
}) => (dispatch, getState) => {
  const store = getStore(getState());

  const { isRetrying }  = store.settings;

  const {
    finalizePurchase: {
      paymentOptions,
      order: order,
    },
    settings: {
      seller: { username },
    },
  } = isRetrying ? store.retry : store;

  const { walletList } = paymentOptions[getPaymentOptionKey(paymentOption)];
  const getWallet = walletList.find(wallet => wallet.id === walletId);

  try {
    /* globals MojoUser */
    Analytics.sendEvent('Selected Wallet Provider', {
      'bank_name': getWallet ? getWallet.name : '',
      'buyer_id': MojoUser ? MojoUser.id : null,
      'order_id': order,
      'seller_username': username,
    });
  } catch (e) {}

  dispatch({
    type: HANDLE_SELECT_WALLET,
    payload: {
      walletId,
    },
  });
};

export const HANDLE_SELECT_BANK = 'HANDLE_SELECT_BANK';
export const handleSelectBank = ({
  bankId, paymentOption,
}) => (dispatch, getState) => {
  const store = getStore(getState());

  const { isRetrying }  = store.settings;

  const {
    finalizePurchase : {
      paymentOptions,
      order: orderId,
    },
    settings: {
      seller: { username },
    },
  } = isRetrying ? store.retry : store;

  const { nbList } = paymentOptions[getPaymentOptionKey(paymentOption)];
  const getBank = nbList.find(bank => bank.id === bankId);

  try {
    /* globals MojoUser */
    Analytics.sendEvent('Selected Netbanking Bank', {
      'bank_name': getBank ? getBank.name : '',
      'buyer_id': MojoUser ? MojoUser.id : null,
      'order_id': orderId,
      'seller_username': username,
    });
  } catch (e) {}

  dispatch({
    type: HANDLE_SELECT_BANK,
    payload: {
      bankId,
    },
  });
};

export const HANDLE_BANK_PAYMENT_FAILURE = 'HANDLE_BANK_PAYMENT_FAILURE';
const handleBankPaymentFailure = () => ({
  type: HANDLE_BANK_PAYMENT_FAILURE,
});

export const HANDLE_BANK_PAYMENT_SUCCESS = 'HANDLE_BANK_PAYMENT_SUCCESS';
const handleBankPaymentSuccess = () => ({
  type: HANDLE_BANK_PAYMENT_SUCCESS,
});

export const handleBankPaymentRequest = () => (dispatch, getState) => {
  const store = getStore(getState());
  const { selectedBankId } = store.settings.isRetrying ? store.retry.finalizePurchase : store.finalizePurchase;

  if (!selectedBankId) {
    dispatch(handleBankPaymentFailure());
  } else {
    dispatch(handleBankPaymentSuccess());
    dispatch(handleAwaitingPaymentCompletion());
  }
};

export const HANDLE_WALLET_PAYMENT_SUCCESS = 'HANDLE_WALLET_PAYMENT_SUCCESS';
const handleWalletPaymentSuccess = () => ({
  type: HANDLE_WALLET_PAYMENT_SUCCESS,
});

export const HANDLE_WALLET_PAYMENT_FAILURE = 'HANDLE_WALLET_PAYMENT_FAILURE';
const handleWalletPaymentFailure = () => ({
  type: HANDLE_WALLET_PAYMENT_FAILURE,
});

export const handleWalletPaymentRequest = () => (dispatch, getState) => {
  const store = getStore(getState());
  const { selectedWalletId } = store.settings.isRetrying ? store.retry.finalizePurchase : store.finalizePurchase;

  if (!selectedWalletId) {
    dispatch(handleWalletPaymentFailure());
  } else {
    dispatch(handleWalletPaymentSuccess());
    dispatch(handleAwaitingPaymentCompletion());
  }
};

export const STORE_FINAL_PAYLOAD = 'STORE_FINAL_PAYLOAD';
export const storeFinalPayload = (finalPayload) => ({
  type: STORE_FINAL_PAYLOAD,
  payload: {
    finalPayload,
  },
});


export const HANDLE_CHANGE_EMI_CARD_PROVIDER = 'HANDLE_CHANGE_EMI_CARD_PROVIDER';
export const handleChangeEMICardProvider = ({ bankKey, paymentOption }) => ({
  type: HANDLE_CHANGE_EMI_CARD_PROVIDER,
  payload: {
    bankKey,
    paymentOption,
  },
});


export const HANDLE_CHANGE_EMI_TENURE = 'HANDLE_CHANGE_EMI_TENURE';
export const handleChangeEMITenure = (tenure, emiAmount) => ({
  type: HANDLE_CHANGE_EMI_TENURE,
  payload: {
    tenure, emiAmount,
  },
});

export const HANDLE_SUBMIT_EMI_FORM_SUCCESS = 'HANDLE_SUBMIT_EMI_FORM_SUCCESS';
export const handleSubmitEMIForm = () => ({
  type: HANDLE_SUBMIT_EMI_FORM_SUCCESS,
});

export const HANDLE_CHANGE_SELECTED_EMI_PROVIDER = 'HANDLE_CHANGE_SELECTED_EMI_PROVIDER';
export const handleChangeSelectedEMIProvider = () => ({
  type: HANDLE_CHANGE_SELECTED_EMI_PROVIDER,
});

export const HANDLE_TOGGLE_LOADER = 'HANDLE_TOGGLE_LOADER';
export const handleHideLoader = () => ({
  type: HANDLE_TOGGLE_LOADER,
});

export const HANDLE_RESET_SELECTED_PAYMENT_MODE = 'HANDLE_RESET_SELECTED_PAYMENT_MODE';
export const handleResetSelectedPaymentMode = () => (dispatch) => {
  if (upiPollId) {
    clearInterval(upiPollId);
    upiPollId = null;
  }
  dispatch({
    type: HANDLE_RESET_SELECTED_PAYMENT_MODE,
  });
};


export const HANDLE_CHANGE_UPI_HANDLE = 'HANDLE_CHANGE_UPI_HANDLE';
export const handleChangeUPIHandle = (handle) => ({
  type: HANDLE_CHANGE_UPI_HANDLE,
  payload: {
    handle,
  },
});

import { POST_API } from 'middlewares/form';
import LGTM from 'lgtm';
const upiHandleValidator =
  LGTM.validator()
    .validates('virtualAddress')
      .required('Please enter your virtual UPI address')
      .using(addr => addr.indexOf('@') > 0, 'Please enter a valid UPI address')
    .build();

export const HANDLE_SUBMIT_UPI_REQUEST = 'HANDLE_SUBMIT_UPI_REQUEST';
export const HANDLE_SUBMIT_UPI_SUCCESS = 'HANDLE_SUBMIT_UPI_SUCCESS';
export const HANDLE_SUBMIT_UPI_FAILURE = 'HANDLE_SUBMIT_UPI_FAILURE';
export const handleSubmitUPI = ({ paymentOption }) => (dispatch, getState) => {
  const store = getStore(getState());
  const finalizePurchase = store.settings.isRetrying ? store.retry.finalizePurchase : store.finalizePurchase;

  Analytics.sendEvent('Input UPI VPA', {
    vpa_code: finalizePurchase.upiHandle,
  });

  const { submissionUri } = finalizePurchase
    .paymentOptions[getPaymentOptionKey(paymentOption)];

  dispatch({
    [POST_API]: {
      types: [
        HANDLE_SUBMIT_UPI_REQUEST,
        HANDLE_SUBMIT_UPI_SUCCESS,
        HANDLE_SUBMIT_UPI_FAILURE,
      ],
      endpoint: submissionUri,
      payload: () => ({
        virtualAddress: finalizePurchase.upiHandle,
      }),
      validator: upiHandleValidator,
      toValidate: () => ({
        virtualAddress: finalizePurchase.upiHandle,
      }),
      onSuccess: (response, state, dispatch) => {
        const { statusCode, statusCheckUrl } = response;
        if (statusCode === 2 && statusCheckUrl) {
          dispatch(pollForUPIAcceptance(statusCheckUrl));
        }
      },
      failureActionErrors: response => response,
    },
  });
};

import { CALL_API } from 'middlewares/api';
let upiPollId;
const pollForUPIAcceptance = (statusCheckUrl) => (dispatch) => {
  upiPollId = setInterval(() => {
    dispatch({
      [CALL_API]: {
        types: ['__', '__', '__'],
        blocking: false,
        endpoint: statusCheckUrl,
        onSuccess: (response) => {
          if (response.statusCode !== 2) {
            // success
            clearInterval(upiPollId);
            window.location.href = response.finalizeUpiSuccessUri;
          }
        },
      },
    });
  }, 2000);
};



// WEBPACK FOOTER //
// ./src/payments/actions/FinalizePurchaseActions.js